<template>
    <div class="page white_bg">

        <header class="pageHeader white_bg" style="line-height: 46px;">
            <div class="borderLayout paddingH16">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 46px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                    </div>
                </div>
            </div>
        </header>

        <div class="body">

            <div class="generalPagePaddingH" style="margin-top: 12px;">
                <div class="filterArea">
                    <span class="textLabel yellowTextLabel" :class="{active : timeFilterItem.id == selectedTimeFilter}"
                          v-for="timeFilterItem in timeFilterTypeList" :key="timeFilterItem.id"
                          @click="changeTimeFilter(timeFilterItem)">
                        {{timeFilterItem.title}}
                    </span>
                </div>
            </div>

            <div class="paddingH20" style="margin-top: 27px;">

                <div class="dataItem borderBBB" v-for="dataItem in dataList" :key="dataItem.id">
                    <div class="padding12">
                        <div class="color101010">分销商姓名：{{dataItem.userName}}</div>
                        <div class="color777">分销ID：{{dataItem.introduceCode}}</div>
                        <div class="color777" style="margin-top: 36px;">开通时间：{{formatDate(dataItem.createTime)}}</div>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何项目
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多项目了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>


        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";

const config = {
    name : 'agencyMemberList',
    title : '团队成员',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/agency/getMemberInfoList',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            params : {}
        },
        get: {
            url: 'portal/v2/distribution/agency/get/info',
            dataPath : 'data'
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : false,
            enableDataItem : true,

            filters : {
                range : ''
            },

            timeFilterTypeList : [{
                title : '全部',
                id : null
            },{
                title : '今日',
                id : 1
            },{
                title : '本周',
                id : 2
            },{
                title : '本月',
                id : 3
            }],
            selectedTimeFilter : null,
        }
    },
    methods : {
        onLoadDataItem() {
            this.apiConfig.list.params.agencyId = this.dataItem.id;
            this.reloadDataList();
        },
        viewItem(dataItem) {
            appHelper.goToPage('', {
                id : dataItem.id
            });
        },
        changeTimeFilter(item) {
            this.selectedTimeFilter = this.filters.range = item.id;
            this.reloadDataList();
        },
    },
    mounted() {

        this.loadDataItem();

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

.filterArea {
    .textLabel {
        width: 56px;
        height: 22px;
        line-height: 22px;
        border: none;
        padding: 0;
        border-radius: 12px;
        margin-right: 16px;
        background-color: hsla(230, 30%, 96%, 1);
        text-align: center;
        font-size: 14px;
        color: hsla(219, 9%, 39%, 1);
        &.active {
            background-color: hsla(36, 100%, 57%, 1);
            color: white;
        }
    }
}
</style>
